import classNames from 'classnames/bind';
import styles from './AnimatedBar.module.css';
import { useSpring, animated } from 'react-spring';

interface AnimatedBar {
  width: string;
  color?: string;
  idx?: number;
}

export default function AnimatedBar({ width, color, idx = 0 }: AnimatedBar) {
  const cx = classNames.bind(styles);
  const springProps = useSpring({
    width: width,
    from: { width: '0%' },
    config: { duration: 300 },
    delay: (idx + 1) * 60,
  });

  return (
    <animated.span
      className={cx('bar_graph')}
      style={{ ...springProps, backgroundColor: color }}
    ></animated.span>
  );
}
